import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SurveyQuestion } from '../models/survey-question.model';
import { SurveyService } from '../services/survey.service';
import { Observable } from "rxjs";
import { debounceTime, startWith, switchMap } from "rxjs/operators";
import { PeopleDto } from "../models/people.model";
import { DataService } from '../services/GlobalService/data.service';
import { LocalstorageService } from '../services/localstorage.service';
import { AuthDetails } from '../models/auth-details.model';


@Component({
  selector: 'ui-people-picker',
  styleUrls: ['./ui-styles.css'],
  template: `<mat-form-field
    *ngIf="currentQuestion?.dataTypeName == 'peoplePicker' || currentQuestion?.dataTypeName == 'Team Member'"
  >
    <input
      type="text"
      matInput
      name="currentQuestion.dataFieldName-{{ currentQuestion.questionId }}"
      [formControl]="peoplePickerControl"
      placeholder="Search team member"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="onSelectPeople($event)" [displayWith]="displayEmployeeName">
      <mat-option
        *ngFor="let option of filteredPeople | async"
        [value]="option.value">
        <b> {{ option.corpId }} </b> - {{ option.employeeName }},
        {{ option.jobDesc }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>`,
})
export class PeoplePickerComponent {
  textareaInput = new UntypedFormControl("");
  private _currentQuestion: SurveyQuestion;
  displayEmployeeName = (value: string): string => {
    if (value) {
      const parts = value.split(';');
      if (parts.length > 1) {
        return parts[1];
      }
    }
    return '';
  };
  @Input() TMName: string = '';
  @Input() set currentQuestion(value) {
    this._currentQuestion = value;
  };
  @Output() personSelected = new EventEmitter<PeopleDto>();
  onSelectedPeople(selected: string) {
    this.dataService.setSelectedPerson(selected);
  }
  get currentQuestion() {
    return this._currentQuestion;
  };

  filteredPeople: Observable<PeopleDto[]>;
  peoplePickerControl: UntypedFormControl;
  userData: AuthDetails;
  constructor(private surveyService: SurveyService, private dataService: DataService, private localstorageService: LocalstorageService) { }

  ngOnInit() {
    this.peoplePickerControl = new UntypedFormControl();
    this.filteredPeople = this.peoplePickerControl.valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((value) => this.surveyService.getPeople(value))
    );

    this.userData = this.localstorageService.getAuth();
  }

  ngAfterViewInit() {
    if (this.TMName) {
      this.peoplePickerControl.setValue(this.TMName);
    }
  }

  onSelectPeople(event) {
    //this.currentQuestion.answerText = event.option.value.split("-")[0];
    const selectedPersonJobDesc: string = event.option.value.split(";")[2];
    selectedPersonJobDesc.replace("''", "'");
    console.log("selectedPersonJobDesc: ", selectedPersonJobDesc);

    this.dataService.setSelectedPerson(selectedPersonJobDesc);
    console.log(event.option.value);
    console.log("Check Mgr Mail: ", event.option.value.split(";")[4]);
    this.currentQuestion.answerText = event.option.value + ';' + this.userData.verificationData.workEmail + ';' + this.userData.employeeInfo.firstName + ';' + this.userData.employeeInfo.lastName;
    this.TMName = event.option.value.split(";")[1];
    console.log("TM Name: ", this.currentQuestion.answerText);
    //this.dataService.setTMDetails()
    //this.currentQuestion.answerText = this.TMName;
  }
}
